import { Container, Stack, Title, Text, Button, Card, Group } from '@mantine/core'
import { IconAlertTriangle, IconRefresh } from '@tabler/icons-react'

function ErrorFallback({ error, resetError }) {
  return (
    <Container size="sm" style={{ marginTop: '100px' }}>
      <Card shadow="md" padding="xl" radius="md">
        <Stack align="center" gap="md">
          <IconAlertTriangle size={64} color="red" />

          <Title order={2}>Something went wrong</Title>

          <Text c="dimmed" ta="center" size="sm">
            We encountered an unexpected error. This has been automatically reported to our team.
          </Text>

          {import.meta.env.DEV && error && (
            <Card bg="gray.0" p="md" radius="sm" w="100%" style={{ marginTop: '16px' }}>
              <Text size="xs" fw={500} mb="xs">Error Details (dev only):</Text>
              <Text size="xs" c="red" style={{ fontFamily: 'monospace', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                {error.message}
              </Text>
            </Card>
          )}

          <Group mt="md">
            <Button
              leftSection={<IconRefresh size={16} />}
              onClick={resetError}
            >
              Try Again
            </Button>

            <Button
              variant="light"
              onClick={() => window.location.href = '/'}
            >
              Go to Homepage
            </Button>
          </Group>

          <Text size="xs" c="dimmed" mt="md">
            If this problem persists, please contact support
          </Text>
        </Stack>
      </Card>
    </Container>
  )
}

export default ErrorFallback
